import { ORDEM_ETAPAS } from "./etapas";

function startOfDayLocal(value) {
  const date = value instanceof Date ? new Date(value) : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
}

function ddmm(date) {
  return `${String(date.getDate()).padStart(2, "0")}/${String(
    date.getMonth() + 1
  ).padStart(2, "0")}`;
}

export function expandirLogGargalo(log, { hoje = new Date(), dias = 60 } = {}) {
  const today = startOfDayLocal(hoje);
  if (!today) return [];
  const totalDias = Math.max(1, Math.floor(dias));

  const ordenado = (Array.isArray(log) ? log : [])
    .map((entry) => ({
      ...entry,
      _date: startOfDayLocal(entry?.data),
    }))
    .filter((entry) => entry._date)
    .sort((left, right) => left._date - right._date);

  const inicio = new Date(today);
  inicio.setDate(inicio.getDate() - (totalDias - 1));

  const dias_arr = [];
  let cursorIdx = -1;
  let etapaAtual = null;

  for (
    const d = new Date(inicio);
    d <= today;
    d.setDate(d.getDate() + 1)
  ) {
    while (
      cursorIdx + 1 < ordenado.length &&
      ordenado[cursorIdx + 1]._date <= d
    ) {
      cursorIdx++;
      etapaAtual = ordenado[cursorIdx].etapa;
    }
    dias_arr.push({
      data: new Date(d),
      label: ddmm(d),
      etapa: etapaAtual && ORDEM_ETAPAS.includes(etapaAtual) ? etapaAtual : null,
    });
  }

  return dias_arr;
}

export function distribuicaoEtapaNoPeriodo(diasExpandidos) {
  const counts = Object.fromEntries(ORDEM_ETAPAS.map((etapa) => [etapa, 0]));
  let semDado = 0;
  for (const dia of diasExpandidos) {
    if (!dia.etapa) {
      semDado++;
      continue;
    }
    counts[dia.etapa] = (counts[dia.etapa] || 0) + 1;
  }
  return { counts, semDado };
}
